export default "__VITE_ASSET__ByJM2CQT__"